import {
    FETCH_OT_NONALLOCATED_LOC_REQUEST,
    FETCH_OT_NONALLOCATED_LOC_SUCCESS,
    FETCH_OT_NONALLOCATED_LOC_FAILURE,
} from "../constants/OTNonAllocatedLocConstants";

const initialState = {
    loading: false,
    data: [],
    error: null,
};

const OTNonAllocatedLocReducer = (state = initialState, action) => {
    switch (action.type) {
        case FETCH_OT_NONALLOCATED_LOC_REQUEST:
            return {
                ...state,
                loading: true,
                error: null,
            };

        case FETCH_OT_NONALLOCATED_LOC_SUCCESS:
            return {
                ...state,
                loading: false,
                data: action.payload,
                error: null,
            };

        case FETCH_OT_NONALLOCATED_LOC_FAILURE:
            return {
                ...state,
                loading: false,
                error: action.payload,
            };

        default:
            return state;
    }
};

export default OTNonAllocatedLocReducer;
